module.exports = __webpack_public_path__ + "img/level_two_lock.7a956050.png";